import { Component, Input, OnInit } from '@angular/core';
import { CourseService } from '@app/_services/course.service';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-page-right-button',
  templateUrl: './page-right-button.component.html'
})
export class PageRightButtonComponent implements OnInit {
  faArrowRight = faArrowRight;

  @Input()
  disabled!: boolean

  @Input()
  visible!: boolean

  @Input()
  nextUnit!: boolean

  @Input()
  nextModule!: boolean

  @Input()
  nextUnitId!: number

  @Input()
  nextModuleId!: number

  constructor(
    private store: Store<{ coursePlayerState: fromCoursePlayer.State }>,
    private courseService: CourseService) {           
  }  

  ngOnInit(): void {
  }

  forward() {

    if (this.disabled) return;
    
    if ((this.nextUnit && this.nextUnitId > -1) || (this.nextModule && this.nextModuleId > -1)) {      
      const course = this.courseService.getCourseData();
      const courseId = course.courseId;
      const courseData = course.courseData;
                  
      this.nextUnitId = this.nextUnitId > -1 ? this.nextUnitId : 0;
      this.nextModuleId = this.nextModuleId > -1 ? this.nextModuleId : 0;

      let pages = [];
      let unit = courseData.entities.units[this.nextUnitId];
      let module = courseData.entities.modules[this.nextModuleId];
      
      for (let [key, value] of Object.entries(courseData.entities.pages)) {      
        if (value['unitId'] === this.nextUnitId) {          
          pages.push(value);
        }
      }            

      console.log("COURSE ID", courseId)

      this.store.dispatch(new actions.Load(
        pages.map(o => {
          return {
            id: o.id,
            pageUrl: o.image,
            content: o.content,
            audioIndex: o.audio.length > 0 ? o.audio[0] : -1,
            isStart: o.isStart,
            isEnd: o.isEnd,
            nextModule: o.nextModule,
            nextModuleId: o.nextModuleId,
            nextUnit: o.nextUnit,
            nextUnitId: o.nextUnitId,
            prevModule: o.prevModule,
            prevModuleId: o.prevModuleId,
            prevUnit: o.prevUnit,
            prevUnitId: o.prevUnitId,
            unitId: o.unitId,
            moduleId: o.moduleId,
            audioCount: o.audioCount
          }
        }),
        courseId,
        unit.audio,       
        module.name, 
        unit.name
      ));


    }    
    else
      this.store.dispatch(new actions.PageRight());
    }    
  }
